import React, { useState, createContext, useEffect, ReactElement } from 'react'
import { isMobile, isBrowser } from 'react-device-detect'
import merge from 'lodash/merge'
import set from 'lodash/set'

import { ThemeOptions } from './Themer.types'
import { object } from 'prop-types'
const defaultScreenWidthConfig = {
    xs: 400,
    sm: 600,
    md: 1000,
    lg: 1200,
    xl: 1600,
}

const screenSizeConfig = {
    width: defaultScreenWidthConfig,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    screenSizeContext: null,
}

const defaultTheme = {
    mode: 'LIGHT',
    colors: {
        background: '#f6f6f7',
    },
    spacing: 8,
    screenSizeConfig,
    isMobile,
    isBrowser,
    inputType: 'default',
}

export interface IThemeContext {
    theme: ThemeOptions
    initialScreenSizeCalComplete: boolean
    setMode: (mode: 'LIGHT' | 'EDISON' | 'DARK' | 'FINN') => void
    setInputType: (type) => any
}

export const ThemeContext = createContext<Partial<IThemeContext>>({})

export interface ThemeProps {
    theme?: ThemeOptions
    themeMode?: 'EDISON' | 'LIGHT' | 'DARK' | 'FINN'
}

const Themer: React.FC<ThemeProps> = ({ themeMode = 'LIGHT', theme = {}, children }) => {
    const [themeState, setThemeState] = useState(merge(defaultTheme, theme, { mode: themeMode }))
    const [initialScreenSizeCalComplete, setInitialScreenSizeCalComplete] = useState(false)
    const updateTheme = (val) => {
        const _themeState = merge(Object.assign(themeState), { ...val })
        // const _themeState = set(Object.assign(themeState), { ...val })
        setThemeState({ ..._themeState })
    }

    const calculateScreenSize = () => {
        const { screenSizeConfig } = Object.assign(themeState)
        const widthConfig = screenSizeConfig.width
        const screenWidth = window.innerWidth
        const screenHeight = window.innerHeight

        let screenSizeContext
        if (screenWidth <= widthConfig.xs) {
            screenSizeContext = 'xs'
        } else if (screenWidth > widthConfig.xs && screenWidth <= widthConfig.sm) {
            screenSizeContext = 'sm'
        } else if (screenWidth > widthConfig.sm && screenWidth <= widthConfig.md) {
            screenSizeContext = 'md'
        } else if (screenWidth > widthConfig.md && screenWidth <= widthConfig.lg) {
            screenSizeContext = 'lg'
        } else if (screenWidth > widthConfig.lg) {
            screenSizeContext = 'xl'
        }

        screenSizeConfig.screenWidth = screenWidth
        screenSizeConfig.screenHeight = screenHeight
        screenSizeConfig.screenSizeContext = screenSizeContext
        updateTheme({ screenSizeConfig })
        if (!initialScreenSizeCalComplete) {
            setInitialScreenSizeCalComplete(true)
        }
    }

    const setMode = (mode: 'EDISON' | 'LIGHT' | 'DARK' | 'FINN') => {
        const x = Object.assign(themeState)
        x.mode = mode
        setThemeState({ ...x })
    }

    useEffect(() => {
        setMode(themeMode)
    }, [themeMode])

    const setInputType = (type) => {
        const theme = Object.assign(themeState)

        theme.inputType = type
        setThemeState({ ...theme })
    }

    useEffect(() => {
        calculateScreenSize()
        window.addEventListener('resize', calculateScreenSize)
        return () => {
            window.removeEventListener('resize', calculateScreenSize)
        }
    }, [])

    const themeContext = {
        theme: themeState,
        initialScreenSizeCalComplete,
        updateTheme,
        setMode,
        setInputType,
    }

    return (
        <ThemeContext.Provider value={themeContext}>
            {typeof children === 'function' ? children(themeContext) : children}
        </ThemeContext.Provider>
    )
}
export default Themer

// class Themere extends React.Component<ThemeProps, any> {
//     constructor(props: ThemeProps) {
//         super(props)
//         const { theme } = props
//
//         this.state = merge(defaultTheme, theme)
//     }
//
//     calculateScreenSize = () => {
//         this.setState((prevState) => {
//             const { screenSizeConfig } = prevState
//             const widthConfig = screenSizeConfig.width
//             const screenWidth = window.innerWidth
//             const screenHeight = window.innerHeight
//
//             let screenSizeContext
//             if (screenWidth <= widthConfig.xs) {
//                 screenSizeContext = 'xs'
//             } else if (screenWidth > widthConfig.xs && screenWidth <= widthConfig.sm) {
//                 screenSizeContext = 'sm'
//             } else if (screenWidth > widthConfig.sm && screenWidth <= widthConfig.md) {
//                 screenSizeContext = 'md'
//             } else if (screenWidth > widthConfig.md && screenWidth <= widthConfig.lg) {
//                 screenSizeContext = 'lg'
//             } else if (screenWidth > widthConfig.lg) {
//                 screenSizeContext = 'xl'
//             }
//
//             screenSizeConfig.screenWidth = screenWidth
//             screenSizeConfig.screenHeight = screenHeight
//             screenSizeConfig.screenSizeContext = screenSizeContext
//             return { screenSizeConfig }
//         })
//     }
//
//     componentDidMount() {
//         this.calculateScreenSize()
//         window.addEventListener('resize', this.calculateScreenSize)
//     }
//
//     componentWillUnmount() {
//         window.removeEventListener('resize', this.calculateScreenSize)
//     }
//
//     render() {
//         console.log('THEME STATE', this.state)
//         return <ThemeContext.Provider value={this.state}>{this.props.children(this.state)}</ThemeContext.Provider>
//     }
// }
// export default Themer
